import Image, { ImageProps } from 'next/image'

export const ImageCM = ({
  src,
  width,
  height,
  quality = 80,
  useMediaUrl = false,
  ...props
}: {
  src: string
  width?: number
  height?: number
  quality?: number
  useMediaUrl?: boolean
  alt?: string
} & Omit<ImageProps, 'src' | 'width' | 'height' | 'alt'>) => {
  const mediaUrl = process.env.NEXT_PUBLIC_MEDIA_URL || ''

  const imageUrl = (() => {
    if (!src || typeof src !== 'string' || !mediaUrl) return ''

    try {
      const processedPath = src
        .replace(/^\/?image\//, 'uploads/')
        .replace(/^\//, '')

      const url = new URL(mediaUrl.replace(/\/$/, ''))

      if (useMediaUrl) {
        url.pathname += `/cdn-cgi/image/`
        url.pathname += `${width ? `width=${width},` : ''}${height ? `height=${height},` : ''}quality=${quality},format=auto/${processedPath}`
      } else {
        url.pathname += `image/${processedPath}`
      }

      return url.toString()
    } catch (error) {
      console.error('🚀 ~ ImageCM ~ getImageUrl ~ error:', error, src)
      return ''
    }
  })()

  if (!imageUrl) return null

  return (
    <Image
      src={imageUrl}
      alt={props?.alt || 'Image'}
      width={width || 100}
      height={height || 100}
      quality={quality}
      {...props}
    />
  )
}
